import {createErrorHandlingThunk} from "../../../auth/redux/utils";
import {Service, ServiceDocumentData, UpdateServiceData, UpdateServiceResult} from "./types";
import {ServicesService} from "./Services.service";

const servicesService = new ServicesService();

export const createServiceThunk = createErrorHandlingThunk<Service, ServiceDocumentData>(
    'services/create',
    (dto) => servicesService.createService(dto)
);

export const updateServiceThunk = createErrorHandlingThunk<UpdateServiceResult, { id: string, dto: UpdateServiceData }>(
    'services/update',
    ({id, dto}) => servicesService.updateService(id, dto)
);

export const listServicesThunk = createErrorHandlingThunk('services/list', servicesService.listServices);

export const getServiceThunk = createErrorHandlingThunk<Service, {id: string}>(
    'services/get',
    ({id}) => servicesService.getService(id)
);

export const changeServicePositionThunk = createErrorHandlingThunk<Service[], {id: string; variant: "increment" | "decrement"}>(
    'service/change-pos',
    ({id, variant}) => servicesService.changeServicePosition(id, variant)
);
